import { GateOperatingState } from '@/__generated__/graphql';
import { type I18n } from '@lingui/core';
import { t } from '@lingui/macro';

export const translateOperatingState = (status: GateOperatingState, i18n: I18n) => {
  const translationMap: Record<GateOperatingState, string> = {
    [GateOperatingState.Idle]: t(i18n)`Disponible`,
    [GateOperatingState.Operating]: t(i18n)`En curso`,
  };
  return translationMap[status];
};
